import { Alert } from '@mui/material';
import { Outlet } from 'react-router';
import { Loader } from '../../components/Loader/Loader';
import { useRespondentApprovalStatuses } from '../../services/queries-hooks/RespondentApprovalStatusQueriesHooks';
import { usePortCos } from '../Finance2/hooks/usePortCos';
import { ConfirmDeleteRequest } from './components/KPIRequests/components/ConfirmDeleteRequest';
import { useRespondentApprovalsEnabled } from './hooks/useRespondentApprovalsEnabled';

export function KpiLoader() {
  const { dataReady, loading, error } = usePortCos();
  const respondentApprovalsEnabled = useRespondentApprovalsEnabled();
  const { isLoading: respondentStatusesLoading } = useRespondentApprovalStatuses(respondentApprovalsEnabled);

  if (error) {
    return <Alert severity='error'>Error loading data. Please try again later.</Alert>;
  }
  if (loading || respondentStatusesLoading) {
    return <Loader />;
  }
  if (!dataReady) {
    return null;
  }

  return (
    <>
      <CommonKpiModals />
      <Outlet />
    </>
  );
}

function CommonKpiModals() {
  return (
    <>
      <ConfirmDeleteRequest />
    </>
  );
}
